// extracted by css-extract-rspack-plugin
export default {"errorIcon":"ListError-module__errorIcon__8SHjWdK","errorMessage":"ListError-module__errorMessage__ndk81x9","retryLink":"ListError-module__retryLink__YmB07Oj"};